import { CHECKIN_DEMO_FLOW, DEMO_FLOW_ENABLED, EARLY_CHECKIN, MOBILE_CHECKIN, PRE_CHECKIN } from "../config/Constant";
import { setPreCheckInWidgetState } from "../Redux/Reducers/checkInReducer";
import { AesUtil } from "./AesUtil";


export const checkPreCheckInWidgetState = () => {

    return async (dispatch, getState) => {

        const { mobileCheckInConfigs } = getState().deviceConfigSlice.webAppWidgetsInfo;
        const { preCheckInCompleted, preCheckInData } = getState().checkInSlice.preCheckInStatus;
        const { serverTimeDataObj } = getState().serverDateTimeSlice;

        if (mobileCheckInConfigs.preCheckInEnabled) {
            if (preCheckInCompleted) {
                if (!mobileCheckInConfigs.mobileCheckInDisabled) {

                    const serverDateTime = new Date(serverTimeDataObj.date);
                    const checkinStartDateTime = new Date(`${preCheckInData.checkinDate}T${mobileCheckInConfigs.checkInStartTime ? mobileCheckInConfigs.checkInStartTime : "00:00:00"}`);
                    const earlyCheckinStartDateTime = mobileCheckInConfigs.earlyCheckInStartTime && new Date(`${preCheckInData.checkinDate}T${mobileCheckInConfigs.earlyCheckInStartTime}`);

                    console.log("checking pre checkin widget as per server time")
                    console.log(serverDateTime)
                    console.log(checkinStartDateTime)
                    console.log(earlyCheckinStartDateTime)


                    if(DEMO_FLOW_ENABLED || CHECKIN_DEMO_FLOW){
                        dispatch(setPreCheckInWidgetState(MOBILE_CHECKIN));
                        return;
                    }

                    if (mobileCheckInConfigs.earlyCheckInEnabled) {

                        if (serverDateTime < earlyCheckinStartDateTime) {
                            dispatch(setPreCheckInWidgetState(PRE_CHECKIN));
                            return;
                        } else if (serverDateTime >= earlyCheckinStartDateTime && serverDateTime < checkinStartDateTime) {
                            // If server time is between early checkin and checkin
                            dispatch(setPreCheckInWidgetState(EARLY_CHECKIN));
                            return;
                        } else if (serverDateTime >= checkinStartDateTime) {
                            // If server time is greater than or equal to checkin time
                            dispatch(setPreCheckInWidgetState(MOBILE_CHECKIN));
                            return;
                        }
                        return;
                    }

                    if (serverDateTime >= checkinStartDateTime) {
                        dispatch(setPreCheckInWidgetState(MOBILE_CHECKIN));
                        return;
                    } else {
                        dispatch(setPreCheckInWidgetState(PRE_CHECKIN));
                        return;
                    }

                }

                dispatch(setPreCheckInWidgetState(PRE_CHECKIN));
                return;
            }

            dispatch(setPreCheckInWidgetState(PRE_CHECKIN));
            return;
        }

        dispatch(setPreCheckInWidgetState(MOBILE_CHECKIN));
        return;
    }
}